import React from 'react'

export default function Mute({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className}>
      <path fill="currentColor" d="M42 58V31L28.4 44.4 42 58z"></path>
      <path
        d="M61.4 2.6a2 2 0 0 0-2.8 0L42 19.2V6L24 24H12a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9.2L2.6 58.6a2 2 0 1 0 2.8 2.8l56-56a2 2 0 0 0 0-2.8z"
        fill="currentColor"
      ></path>
    </svg>
  )
}
